// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","293":"component---src-pages-index-js","691":"component---src-pages-cenik-js"}[chunkId] + "-" + {"223":"629089cc947282555b25","293":"df8126d2161f2fa21fc0","691":"a64f81fb2b5717d22f94"}[chunkId] + ".js";
};